<template lang="pug">
  #app
    Popup(v-if="firstVisit")
    NavBar(@switchMenu="switchMenu")
    v-touch.menu-container(v-if="showMenu", v-on:swipeleft="switchMenu")
      .menu-sidebar
        .menu-component
          SideMenu
    router-view.content-container(:key="$route.path")
</template>
<script>

export default {
  name: 'starter',
  data () {
    return {
      showMenu: false
    }
  },
  components: {
    NavBar: () => import('@/components/NavBar'),
    SideMenu: () => import('@/components/SideMenu'),
    Popup: () => import('@/components/Popup')
  },
  computed: {
    firstVisit () {
      return (('/map' === this.$route.path) && !localStorage.getItem('popupShowed'))
    }
  },
  methods: {
    switchMenu () {
      this.showMenu = !this.showMenu
    }
  },
  mounted () {
    this.$root.$on('switchMenu', this.switchMenu)
  }
}
</script>
<style lang="stylus">
@font-face
  font-family 'JEMBOhands'
  src url('~/fonts/Jembohands.eot')
  src url('~/fonts/Jembohands.eot?#iefix') format("embedded-opentype"),
      url('~/fonts/Jembohands.ttf') format("truetype")
@font-face
  font-family 'PEIXE'
  src url('~/fonts/PEIXE.eot')
  src url('~/fonts/PEIXE.eot?#iefix') format("embedded-opentype"),
      url('~/fonts/PEIXE.ttf') format("truetype")
@font-face
  font-family 'Grunge Handwriting'
  src url('~/fonts/Grunge Handwritin.eot')
  src url('~/fonts/Grunge Handwritin.eot?#iefix') format("embedded-opentype"),
      url('~/fonts/Grunge Handwriting.ttf') format("truetype")
#app
  width 100%
  min-height 100vh
  display flex
  flex-direction column
button::-moz-focus-inner
a::-moz-focus-inner
  border 0
a, a:visited, a:focus, a:active, a:hover
  outline 0
.menu-container
  display flex
  width 100%
  position fixed
  top 0
  padding-top 50px
  left 0
  z-index 998
  height 100vh
.content-container
  padding-top 50px
  min-height 100vh
.menu-sidebar
  margin 0 auto
  width 100%
  max-width 940px
  height 100%
.menu-component
  display flex
  justify-content flex-end
  width 100%
  height 100%
  max-width 425px
  @media(orientation: landscape)
    @media(max-height 414px)
      max-width 414px
    @media(max-height 375px)
      max-width 375px
  align-items flex-end
  // @media screen and (max-height: 720px) and (orientation: landscape)
  //   align-items flex-start
  background #fff
  background url('~/img/background-tiles.jpg') top repeat
  background-size 80px
.pac-container
  margin-top 10px
</style>
